import React, { useEffect, useState } from "react";
import PageTitle from "Components/PageTitle/PageTitle";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import NewOlguDialog from "./NewOlguDialog/NewOlguDialog";
import TblOlgu from "./TblOlgu/TblOlgu";
import { getGroupProfileWithType } from "Stores/actions";
import {useDispatch, useSelector} from "react-redux";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import Translator from "Languages/Utility/Translator";

const Olgo = () => {
  const [loading, setLoading] = useState(false);
  const [changes, setChanges] = useState(null);
  const [toggle, setToggle] = useState(1);
  const [profile, setProfile] = useState(null);
  const dispatch = useDispatch();
  const {dasteProfileListWithType} = useSelector(state => ({
    dasteProfileListWithType: state.pattern.dasteProfileListWithType,
  }))

  useEffect(() => {
    (async () => {
      if(dasteProfileListWithType.length === 0) {
        try {
          setLoading(true);
          const params = {
            KeyGroup: read("groupKey"),
            KeyUser: read("userKey"),
            IdType: 1,
          };
          await dispatch(getGroupProfileWithType(params));
          setLoading(false);
        } catch (e) {
          setLoading(false);
        }
      }

    })();
  }, [dasteProfileListWithType]);

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="page-top-title-button my-2">
        <PageTitle title={<Translator id={"patterns"}/>} />
        <div className="top-buttons">
          {
            (read("templateRules").accessRegister !== false) &&
              <NewOlguDialog
                toggle={toggle}
                setToggle={(data) => setToggle(data)}
                setProfile={(data) => setProfile(data)}
                setChanges={(data) => setChanges(data)}
              />
          }
        </div>
      </div>
      <MuiPaper className="mb-5">
        <TblOlgu
          toggle={toggle}
          setToggle={(data) => setToggle(data)}
          changes={changes}
          clearChanges={() => setChanges(null)}
          profile={profile}
        />
      </MuiPaper>
    </>
  );
};

export default Olgo;
